module.exports = __webpack_public_path__ + "assets/all_data_white.4a7d1b2e.svg";